export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return false;
    const lenis = window.__lenis;
    if (lenis) {
        lenis.scrollTo(el, { offset: -84, duration: 1.2 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    return true;
}
